import clsx from 'clsx';
import styles from '../player.module.scss';
import Icona from 'components/3cat/ui/Icona';
import CodiEspectador from 'components/3cat/CodiEspectador';
import AvisUHDHDR from 'components/3catinfo/AvisUHDHDR';
import __isEmpty from 'lodash/isEmpty';

export default function FullScreen(props) {
    const {
        titol,
        nomProg,
        textAud,
        changeAudioDesc,
        aud,
        edat,
        hasVersioOriginal,
        hasSubtitols,
        isHDR,
        controlsVisible = true
    } = props;
    const showEdat = !__isEmpty(edat);
    const showCodis = showEdat || hasVersioOriginal || hasSubtitols || isHDR;

    return (
        <>
            <div className={styles.fullscreenrow}>
                <div className={styles.nom}>{nomProg}</div>
                <div className={styles.titol}>{titol}</div>
                <div className={styles.subinfo}>
                    {showCodis && (
                        <span className={styles.edat}>
                            {showEdat && <CodiEspectador key={edat} codi={edat} mida='20' />}
                            {hasVersioOriginal && <CodiEspectador codi='VO' alt='' mida='20' className={styles.ico_codi} />}
                            {hasSubtitols && <CodiEspectador codi='Subtitols' alt='' mida='20' className={styles.ico_codi} />}
                            {isHDR && <CodiEspectador codi='HDR' alt='' mida='30' className={styles.ico_codi} />}
                        </span>
                    )}
                    {aud && (
                        <button className={styles.boto} aria-label='audiodescripció' onClick={changeAudioDesc}>
                            <div className={styles.boto_text}>{textAud}</div>
                            <Icona estil='clickable' alt='Icona audiodescripció' icona='audiodescripcio' />
                        </button>
                    )}
                </div>
            </div>
            {isHDR && (
                <div className={clsx(styles.avisUHDHDR, !controlsVisible && styles.avisUHDHDRHidden)}>
                    <AvisUHDHDR estil='webview' />
                </div>
            )}
        </>
    );
}
